import { z } from 'zod';

export const tenantSchema = z.object({
  name: z.string().min(2, 'نام مرکز باید حداقل ۲ کاراکتر باشد'),
  description: z
    .string()
    .optional()
    .or(z.literal(''))
    .transform((val) => val || ''),
});
